function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.6 64.6381V90.6476",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M60.6 22.22C65.0625 22.22 68.68 18.6025 68.68 14.14C68.68 9.67754 65.0625 6.06 60.6 6.06C56.1375 6.06 52.52 9.67754 52.52 14.14C52.52 18.6025 56.1375 22.22 60.6 22.22Z",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M70.7 42.418V90.3102C70.7 92.9019 68.2174 94.94 65.65 94.94C63.0826 94.94 60.9838 92.8978 60.6 90.3102",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.502 90.3102C50.502 92.9018 48.0195 94.94 45.452 94.94C42.8846 94.94 40.7858 92.8978 40.402 90.3102",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.3 42.418V90.3102C30.3 92.9019 32.7826 94.94 35.35 94.94C37.9174 94.94 40.0162 92.8978 40.4 90.3102",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.402 90.6819V64.6381",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M38.38 22.216C42.8414 22.216 46.458 18.5993 46.458 14.138C46.458 9.67663 42.8414 6.06 38.38 6.06C33.9187 6.06 30.302 9.67663 30.302 14.138C30.302 18.5993 33.9187 22.216 38.38 22.216Z",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M30.001 62.6341C28.076 62.6341 26.2236 61.61 25.3025 59.8404L20.7535 48.7163C19.9859 47.2377 20.0182 45.4904 20.8424 44.04L24.8945 32.93C25.8439 31.2514 27.6861 30.302 29.5425 30.3H59.7253C60.301 30.3 60.8626 30.1808 61.3878 29.9424C64.0603 28.7284 72.619 24.8379 72.7887 24.7429C73.629 24.2743 74.6552 24.1006 75.7338 24.3571C77.1398 24.6924 78.2972 25.8358 78.6467 27.2376C79.1254 29.1506 78.2386 30.9201 76.758 31.7766C76.2914 32.0473 67.8356 35.9661 64.2279 37.6346C63.1674 38.1275 62.014 38.38 60.8424 38.38H50.5V90.2152C50.5 92.9018 52.9826 94.94 55.55 94.94C58.1174 94.94 60.6 92.9038 60.6 90.3101",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M70.9989 62.618C72.924 62.618 74.7763 61.5939 75.6975 59.8264L80.2465 48.7083C81.0141 47.2296 80.9818 45.4844 80.1576 44.034L76.1055 32.9301",
  stroke: "black",
  strokeWidth: 4.04,
  strokeMiterlimit: 10
});

function SvgFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.fb96547b.svg";
export { ForwardRef as ReactComponent };